@if (formInitialized) {
  <form [formGroup]="form" (ngSubmit)="onSubmit()" class="p-fluid">
    <div class="grid">
      <app-form-field-wrapper
        [label]="'Name'"
        [name]="'name'"
        [colSize]="6"
        [formField]="form.get('name')">
        <input
          pInputText
          id="name"
          type="text"
          formControlName="name"
          class="p-input" />
      </app-form-field-wrapper>

      <app-form-field-wrapper
        [colSize]="4"
        label="Sensibel"
        icon="fas fa-shield-halved"
        tooltip="Sensibele Arbeitsbereiche können nur von Nutzer:innen eingesehen werden, die explizit Zugriff auf diesen gewährt bekommen. Die Fallback-Gruppe 'alle' schließt diese nicht mit ein."
        name="shy">
        <p-inputSwitch id="shy" formControlName="shy"></p-inputSwitch>
      </app-form-field-wrapper>
    </div>

    @if (form.get('shy')?.value) {
      <app-alert styleClass="p-3" [canToggle]="false" severity="info">
        <div class="flex gap-2 align-items-baseline">
          <i class="fas fa-info-circle"></i>
          <span
            >Sensibele Arbeitsbereiche können nur von Nutzer:innen eingesehen
            werden, die explizit Zugriff auf diesen gewährt bekommen. Die
            Fallback-Gruppe "alle" schließt diese nicht mit ein.</span
          >
        </div>
      </app-alert>
    }
    <app-header
      styleClass="mt-5"
      icon="fas fa-search"
      text="Zum Arbeitsbereich zuordnen"
      sub="Fügen Sie Ordner, Räume, Standorte, Themenbereiche und/oder Themen Ihrem Arbeitsbereich hinzu."></app-header>

    <div class="flex w-full flex-1 gap-3 flex-wrap overflow-hidden">
      <div class="flex-shrink-0">
        <p-menu [model]="menuItems" styleClass="w-15rem p-card p-0">
          <ng-template pTemplate="item" let-item>
            <a
              class="flex align-items-center gap-2 p-menuitem-link surface-border">
              <i
                class="text-center"
                style="width: 1.5rem"
                [class]="item.icon"></i>
              <span class="font-semibold"> {{ item.label }} </span>
              <p-badge
                class="ml-auto"
                [value]="workspaceChildren[item.key]?.length || 0" />
            </a>
          </ng-template>
        </p-menu>
      </div>
      <div class="flex-grow-1 flex flex-1 flex-column overflow-hidden h-full">
        @if (active === 'indicatorCategory') {
          <app-category-pick-list
            (selectionChanged)="
              addToWorkspaceChildren('indicatorCategory', $event)
            "
            [selectedIds]="
              workspaceChildren?.indicatorCategory
            "></app-category-pick-list>
        }

        @if (active === 'dataLayerType' || active === 'poiDataLayerType') {
          <div class="grid mb-3">
            <app-form-field-wrapper
              [colSize]="12"
              help="Sie können die Jahre eintragen, in welchen die Nutzer:innen dieser Arbeitsgruppe zugriff auf Daten erhalten sollen. Sie können nach jedem Jahr 'Enter' oder ein ',' eintragen um ein Jahr zu aktivieren. Lassen Sie dieses Feld leer, falls es keine Einschränkungen geben soll."
              label="Zugriff auf Jahre beschränken"
              [formField]="form.get('allowedYears')"
              name="allowedYears">
              <p-chips
                [allowDuplicate]="false"
                formControlName="allowedYears"
                separator=","
                placeholder="2020, 2021, 2022" />
            </app-form-field-wrapper>
          </div>
        }

        @if (active === 'dataLayerType') {
          <app-data-layer-type-pick-list
            (selectionChanged)="typeOrGroupChanged($event, 'Polygon')"
            [selectedIds]="workspaceChildren?.dataLayerType"
            [selectedGroups]="itemToEdit?.typeGroups"
            type="Polygon"></app-data-layer-type-pick-list>
        }
        @if (active === 'poiDataLayerType') {
          <app-data-layer-type-pick-list
            (selectionChanged)="typeOrGroupChanged($event, 'Point')"
            [selectedIds]="workspaceChildren?.poiDataLayerType"
            type="Point"></app-data-layer-type-pick-list>
        }
        @if (active === 'bookmarkCategory') {
          <app-bookmark-category-pick-list
            (selectionChanged)="
              addToWorkspaceChildren('bookmarkCategory', $event)
            "
            [selectedIds]="
              workspaceChildren?.bookmarkCategory
            "></app-bookmark-category-pick-list>
        }
        @if (active === 'topic') {
          <app-topic-pick-list
            (selectionChanged)="addToWorkspaceChildren('topic', $event)"
            [selectedIds]="workspaceChildren?.topic"></app-topic-pick-list>
        }
      </div>
    </div>

    <p-divider />
    <app-form-footer
      [cancelLevel]="cancelLevel"
      [showRemoveButton]="!!itemToEdit"
      [isEditMode]="!!itemToEdit"
      (cancel)="cancel.emit()"
      (removeClick)="
        itemToEdit ? confirm(undefined, itemToEdit, itemToEdit.name) : undefined
      "></app-form-footer>
    <app-debug [debugOutput]="form.value"></app-debug>
  </form>
}
